import { render, staticRenderFns } from "./NewTemplate.vue?vue&type=template&id=b4fa459e&scoped=true"
import script from "./NewTemplate.vue?vue&type=script&lang=js"
export * from "./NewTemplate.vue?vue&type=script&lang=js"
import style0 from "./NewTemplate.vue?vue&type=style&index=0&id=b4fa459e&prod&scoped=true&lang=scss"
import style1 from "./NewTemplate.vue?vue&type=style&index=1&id=b4fa459e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fa459e",
  null
  
)

export default component.exports